import React from 'react'
import { useDocument } from '../store/DocumentContext'

const StatusBar: React.FC = () => {
  const { state } = useDocument()

  return (
    <div className="status-bar">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <span>Ready</span>
          <span>•</span>
          <span>Words: {state.wordCount}</span>
          <span>•</span>
          <span>Characters: {state.characterCount}</span>
          <span>•</span>
          <span>Font: {state.fontFamily} {state.fontSize}pt</span>
        </div>
        <div className="flex items-center gap-4">
          <span>Page 1</span>
          <span>•</span>
          <span>Zoom: 100%</span>
          <span>•</span>
          <span>AI Assistant: Active</span>
        </div>
      </div>
    </div>
  )
}

export default StatusBar 